import SportType from "../../enums/SportType.js";

const baseballOnly = function(sportType) {
    return typeof(sportType) === 'string' && sportType.toUpperCase() === SportType.Baseball.key;
};

export default baseballOnly;